
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import OrientationConfirmation from '@/components/application/OrientationConfirmation';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const OrientationConfirmationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Orientation Scheduled
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Your orientation session has been confirmed
        </p>
        <OrientationConfirmation />
      </div>
    </AppLayout>
  );
};

export default OrientationConfirmationPage;
